import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const SupplierList = Loadable(lazy(() => import("features/supplier/components/List")));
const SupplierPage = Loadable(lazy(() => import("features/supplier/components/Page")));

const routes = {
    path: 'supplier',
    children: [
        { path: '', element: <SupplierList /> },
        { path: 'add', element: <SupplierPage /> },
        { path: 'edit/:supplierID?', element: <SupplierPage /> },
    ]
};

export default routes;